import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Navbar from '../components/Navbar';
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto';

const Tickets = () => {
  const obtenerFechaLocal = () => {
  const hoy = new Date();
  hoy.setMinutes(hoy.getMinutes() - hoy.getTimezoneOffset()); // Ajusta al huso horario local
  return hoy.toISOString().slice(0, 10);
};
  const [fechaDesde, setFechaDesde] = useState(obtenerFechaLocal());
  const [fechaHasta, setFechaHasta] = useState(obtenerFechaLocal());
  const [tickets, setTickets] = useState([]);

  const obtenerTickets = () => {
    axios.get(`https://sistemarab.com/CasinoApp/tickets.php?desde=${fechaDesde}&hasta=${fechaHasta}`)
      .then(res => setTickets(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    obtenerTickets();
  }, [fechaDesde, fechaHasta]);

  const exportarExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(tickets);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tickets");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `tickets_${fechaDesde}_a_${fechaHasta}.xlsx`);
  };

  const formatearFecha = (fechaCompleta) => fechaCompleta.split(' ')[0];

  const ticketsPorDia = tickets.reduce((acc, ticket) => {
    const fecha = formatearFecha(ticket.fecha_ticket);
    acc[fecha] = (acc[fecha] || 0) + 1;
    return acc;
  }, {});

  const ticketsPorDiaArea = {};
  const areas = new Set();
  const fechas = new Set();

  const ticketsPorDiaCentro = {};
  const centros = new Set();

  tickets.forEach(ticket => {
    const fecha = formatearFecha(ticket.fecha_ticket);
    fechas.add(fecha);
    areas.add(ticket.area);
    centros.add(ticket.centro_costo || 'Sin centro de costo');

    ticketsPorDiaArea[fecha] = ticketsPorDiaArea[fecha] || {};
    ticketsPorDiaArea[fecha][ticket.area] = (ticketsPorDiaArea[fecha][ticket.area] || 0) + 1;

    ticketsPorDiaCentro[fecha] = ticketsPorDiaCentro[fecha] || {};
    const centroKey = ticket.centro_costo || 'Sin centro de costo';
    ticketsPorDiaCentro[fecha][centroKey] = (ticketsPorDiaCentro[fecha][centroKey] || 0) + 1;
  });

  const dataDiaArea = {
    labels: Array.from(fechas),
    datasets: Array.from(areas).map(area => ({
      label: area,
      data: Array.from(fechas).map(fecha => ticketsPorDiaArea[fecha]?.[area] || 0),
      backgroundColor: `rgba(${Math.floor(Math.random()*255)},${Math.floor(Math.random()*255)},${Math.floor(Math.random()*255)},0.6)`
    }))
  };

  const dataDiaCentro = {
    labels: Array.from(fechas),
    datasets: Array.from(centros).map(centro => ({
      label: centro,
      data: Array.from(fechas).map(fecha => ticketsPorDiaCentro[fecha]?.[centro] || 0),
      backgroundColor: `rgba(${Math.floor(Math.random()*255)},${Math.floor(Math.random()*255)},${Math.floor(Math.random()*255)},0.6)`
    }))
  };

  const ticketsPorArea = tickets.reduce((acc, ticket) => {
    acc[ticket.area] = (acc[ticket.area] || 0) + 1;
    return acc;
  }, {});

  const ticketsPorCentro = tickets.reduce((acc, ticket) => {
    const key = ticket.centro_costo || 'Sin centro de costo';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  return (     <>
    <section className="section">
      <div className="container">
        <h1 className="title">Tickets </h1>
        <div className="columns">
          <div className="column">
            <label className="label">Desde:</label>
            <div className="control">
              <input type="date" className="input" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
            </div>
          </div>
          <div className="column">
            <label className="label">Hasta:</label>
            <div className="control">
              <input type="date" className="input" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
            </div>
          </div>
          <div className="column is-narrow">
            <label className="label">&nbsp;</label>
            <button className="button is-info" onClick={exportarExcel}>📁 Exportar a Excel</button>
          </div>
        </div>

        <div className="notification is-primary">
          Total de Tickets: {tickets.length}
        </div>

        <div className="columns is-multiline">
            <Bar data={{
              labels: Object.keys(ticketsPorDia),
              datasets: [{ label: 'Tickets por Día', data: Object.values(ticketsPorDia), backgroundColor: 'rgba(54, 162, 235, 0.6)' }]
            }} />

            <Bar data={dataDiaArea} />
          

            <Bar data={dataDiaCentro} />
          
    
        </div>

        <table className="table is-fullwidth is-striped mt-4">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>RUT</th>
              <th>Centro de Costo</th>
              <th>Fecha</th>
              <th>Área</th>
            </tr>
          </thead>
          <tbody>
           {tickets.length === 0 ? (
              <tr>
                <td colSpan="6" className="has-text-centered">No hay tickets en el rango seleccionado</td>
              </tr>
            ) : (
              tickets.map((t, index) => (
                <tr key={index}>
                  <td>{t.nombre}</td>
                  <td>{t.rut}</td>
                  <td>{t.centro_costo}</td>
                  <td>{formatearFecha(t.fecha_ticket)}</td>
                  <td>{t.area}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
    </>
  );
};

export default Tickets;
